import { render, staticRenderFns } from "./create-or-edit-interface-field.vue?vue&type=template&id=3db7d684&scoped=true"
import script from "./create-or-edit-interface-field.vue?vue&type=script&lang=js"
export * from "./create-or-edit-interface-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db7d684",
  null
  
)

export default component.exports